import { useMutation } from "react-query";
import { customApi } from "../../../../../CustomHoock/CustomApi";

export const useGetKlischeTypeRatio = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetKlischeTypeRatio",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
export const useGetOrderKlischeTypeRatio = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetOrderKlischeTypeRatio",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
